<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import { ApiOfficeserviceOffices } from '~~/server/api/officeservice/offices/[slug]'

const route = useRoute()
const router = useRouter()
const { data: page, redirect } = await useFetchWithRedirect<ApiOfficeserviceOffices>(
    `/api/officeservice/offices/${route.params.id}`,
    { route, onNotFound: () => router.push({ name: 'offices' }) }
)

if (redirect && !redirect?.error) {
    navigateTo(redirect.data.url, redirect.data.options)
}

const { $t } = useNuxtApp()
const breadcrumbs = computed<BreadcrumbsLink[]>(() => {
    return [
        {
            name: $t('O nás'),
            slug: useNamedRoutes({ name: 'about' }),
        },
        {
            name: $t('Pobočky a servisy'),
            slug: useNamedRoutes({ name: 'offices' }),
        },
    ]
})

// Page meta
usePageMeta({
    meta: page.value?.data.meta,
    title: `Pobočka KOOPERATIVA - ${page.value?.data.city} - ${page.value?.data.address}`,
    description: `Vašu pobočku KOOPERATIVA v meste ${page.value?.data.city} nájdete na adrese ${page.value?.data.address}.`
})

</script>
<template>
  <article v-if="page">
    <ContainerFluid>
      <Breadcrumbs
        :current="page.data.title"
        :links="breadcrumbs"
        class="border-bottom pb-3 mb-4 mb-md-13"
      />
    </ContainerFluid>
    <PageHeaderContent
      class="mb-3"
      :title="page.data.title"
      :tag="$t('Pobočka')"
      :subtitle="`${page.data.address}, ${page.data.city} ${page.data.zip_code}`"
      text-color="black-100"
    />
    <PagesOfficesDetailNavLink
      class="text-center mb-12"
      :latitude="page.data.lat"
      :longitude="page.data.lng"
      :title="page.data.title"
    />
    <LazyContainerFluid>
      <div class="row mb-2">
        <div class="col-12 col-lg-6 mb-6">
          <LazyPagesOfficesDetailOpeningHours
            :data="page.data.opening_hours"
            :note="page.data.note"
            class="h-100"
          />
        </div>
        <div class="col-12 col-lg-6 mb-6">
          <LazyPagesOfficesDetailContact
            :show-card-pay-box="true"
            :phone-contacts="page.data.phone_contacts"
            :card-pay="page.data.card_pay"
            :show-phone-numbers="page.data.offices_phone_numbers_on"
            type="offices"
            class="h-100"
          />
        </div>
      </div>
      <PagesOfficesDetailNote
        v-if="page.data.note"
        class="mb-8"
        :note="page.data.note"
      />
      <LazyPagesOfficesDetailMap
        :modal-title="$t('Pobočka')"
        :map-zoom="15"
        :data="page.data"
      />
    </LazyContainerFluid>
  </article>
</template>
